<template>
    <div class="page-table tabStyle scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.referans.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.referans.tanimlama.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.referans.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="referansForm" :rules="rulesReferans" ref="referansForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.referans.tanimlama.resim")'
                                                      prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="18" :md="18" :sm="24" :xs="24" class="col-p">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.musteri")'
                                                        prop="musteri">:
                                                    <el-input v-model="referansForm.musteri"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.musteriPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.sektor")'
                                                        prop="sektor">:
                                                    <el-input v-model="referansForm.sektor"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.sektorPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.referans.tanimlama.baslik")'
                                                              prop="baslik">:
                                                    <el-input
                                                            v-model="referansForm.baslik"
                                                            :placeholder='$t("src.views.apps.referans.tanimlama.baslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.proje")'
                                                        prop="proje">:
                                                    <el-input v-model="referansForm.proje"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.projePlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.referansTarihi")'
                                                        prop="referansTarihi">:
                                                    <el-input v-model="referansForm.referansTarihi"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.referansTarihiPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.referans.tanimlama.icerik")'
                                                              prop="icerik">:
                                                    <ckeditor :editor="editor"
                                                              :config="editorConfig"
                                                              v v-model="referansForm.icerik"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.referans.tanimlama.resim")'
                                                      prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="18" :md="18" :sm="24" :xs="24" class="col-p">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.musteri")'
                                                        prop="musteri">:
                                                    <el-input v-model="referansForm.musteri"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.musteriPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.en.sektor")'
                                                        prop="dil.en.sektor">:
                                                    <el-input v-model="referansForm.dil.en.sektor"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.sektorPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.en.baslik")'
                                                        prop="dil.en.baslik">:
                                                    <el-input
                                                            v-model="referansForm.dil.en.baslik"
                                                            :placeholder='$t("src.views.apps.referans.tanimlama.baslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.en.proje")'
                                                        prop="dil.en.proje">:
                                                    <el-input v-model="referansForm.dil.en.proje"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.projePlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.en.referansTarihi")'
                                                        prop="dil.en.referansTarihi">:
                                                    <el-input v-model="referansForm.dil.en.referansTarihi"
                                                              placeholder='January 2020'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.en.icerik")'
                                                        prop="dil.en.icerik">:
                                                    <ckeditor :editor="editor"
                                                              :config="editorConfig"
                                                              v v-model="referansForm.dil.en.icerik"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.referans.tanimlama.resim")'
                                                      prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="18" :md="18" :sm="24" :xs="24" class="col-p">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.musteri")'
                                                        prop="musteri">:
                                                    <el-input v-model="referansForm.musteri"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.musteriPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.de.sektor")'
                                                        prop="dil.de.sektor">:
                                                    <el-input v-model="referansForm.dil.de.sektor"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.sektorPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.de.baslik")'
                                                        prop="dil.de.baslik">:
                                                    <el-input
                                                            v-model="referansForm.dil.de.baslik"
                                                            :placeholder='$t("src.views.apps.referans.tanimlama.baslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.de.proje")'
                                                        prop="dil.de.proje">:
                                                    <el-input v-model="referansForm.dil.de.proje"
                                                              :placeholder='$t("src.views.apps.referans.tanimlama.projePlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.de.referansTarihi")'
                                                        prop="dil.de.referansTarihi">:
                                                    <el-input v-model="referansForm.dil.de.referansTarihi"
                                                              placeholder='Januar 2020'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.tanimlama.dil.de.icerik")'
                                                        prop="dil.de.icerik">:
                                                    <ckeditor :editor="editor"
                                                              :config="editorConfig"
                                                              v v-model="referansForm.dil.de.icerik"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.referans.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                v-model="referansForm.durum"
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini" v-on:click="referansTanimlama('referansForm',referansForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="referansForm.durum === '1'">{{$t('src.views.apps.referans.tanimlama.referansEkle')}}</label>
                                    <label v-else>Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.referans.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('referansForm')">
                                            {{$t('src.views.apps.referans.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.referans.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.referans.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.referans.tanimlama.copKutusu')" :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="referansTanimlama('referansForm','0')" type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.referans.tanimlama.link")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="link">
                                        <el-input v-model="referansForm.link"
                                                  :placeholder='$t("src.views.apps.referans.tanimlama.linkPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.referans.tanimlama.yer")' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="yer">
                                        <el-input v-model="referansForm.yer"
                                                  placeholder="Sivas Merkez"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/tr';

    Vue.use(CKEditor)
    import referansService from '../../../WSProvider/ReferansService'
    import status from '../../../status'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "ReferansTanimla",
        components: {
            ckeditor: CKEditor.component
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            }
        },
        data() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4'],
                visibleSil: false,
                checked: true,

                referansForm: {
                    baslik: '',
                    link: '',
                    durum: "1",
                    musteri: '',
                    sektor: '',
                    image: '',
                    imageBase: '',
                    icerik: '',
                    proje: '',
                    referansTarihi: '',
                    yer: '',
                    dil: {
                        en: {
                            sektor: '',
                            baslik: '',
                            proje: '',
                            referansTarihi: '',
                            icerik: ''
                        },
                        de: {
                            sektor: '',
                            baslik: '',
                            proje: '',
                            referansTarihi: '',
                            icerik: ''
                        }
                    }
                },
                rulesReferans: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    musteri: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            // inputStyle(val, form) {
            //     var splitStr = val.toLowerCase().split(' ');
            //     for (var i = 0; i < splitStr.length; i++) {
            //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            //     }
            //     this.referansForm[form] = splitStr.join(' ');
            // },

            imageRemove() {
                $('.el-upload--picture-card').show();
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.referansForm.musteri) {
                        var imgname = randomText(13) + '-' +linkTemizle(this.referansForm.musteri)+".png";
                    } else {
                        imgname = randomText(13) + '-' +linkTemizle(file.name.split('.')[0])+".png";
                    }
                    this.referansForm.image = imgname;
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            this.referansForm.imageBase = e.target.result;
                        }
                        reader.readAsDataURL(files);
                    }
                } else {
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            referansTanimlama(formName,durum) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let dil = {
                            en: {
                                baslik: this.referansForm.dil.en.baslik,
                                sektor: this.referansForm.dil.en.sektor,
                                icerik: this.referansForm.dil.en.icerik,
                                proje: this.referansForm.dil.en.proje,
                                referansTarihi: this.referansForm.dil.en.referansTarihi
                            },
                            de: {
                                baslik: this.referansForm.dil.de.baslik,
                                sektor: this.referansForm.dil.de.sektor,
                                icerik: this.referansForm.dil.de.icerik,
                                proje: this.referansForm.dil.de.proje,
                                referansTarihi: this.referansForm.dil.de.referansTarihi
                            }
                        };
                        referansService.referansTanimlama(this.referansForm.link, this.referansForm.image, this.referansForm.imageBase,
                            this.referansForm.baslik, this.referansForm.musteri,
                            this.referansForm.sektor, this.referansForm.icerik, this.referansForm.proje, this.referansForm.referansTarihi,
                            this.referansForm.yer,this.referansForm.durum,dil).then((response) => {
                            if (response.status === 200) {
                                if(durum === '0'){
                                    status.Status('success', this, 'Referans başarıyla taslağa kaldırıldı.');
                                }else if(durum === '1'){
                                    status.Status('success', this, 'Referans başarıyla eklendi.');
                                }
                                this.$refs[formName].resetFields();
                                $('.el-upload-list__item-delete').click();
                            }else if(response.status === 230){
                                status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir sayfa referans mevcut');
                            } else {
                                status.Status(response.status, this)
                            }
                        })
                    }
                })
            },
        }
    }
    function linkTemizle(text)
    {
        var trMap = {
            'çÇ':'c',
            'ğĞ':'g',
            'şŞ':'s',
            'üÜ':'u',
            'ıİ':'i',
            'öÖ':'o'
        };
        for(var key in trMap) {
            text = text.replace(new RegExp('['+key+']','g'), trMap[key]);
        }
        return  text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>
<style scoped>
    #affix-container.tabStyle {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }
    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }
</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>